const styleSheet = () => ({
  exploreWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    padding: '0 56px',
    height: '100vh',
    position: 'relative',
    overflowX: 'hidden',
  },
});

export default styleSheet;
